import React, { useEffect, useMemo, useState } from 'react';
import { getEvents, getReports } from '../services/api';

export default function ReportsAudit(){
  const [reports, setReports] = useState([]);
  const [events, setEvents] = useState([]);
  const [search, setSearch] = useState('');
  const [scope, setScope] = useState('all');

  useEffect(()=>{ getReports().then(setReports); },[]);
  useEffect(()=>{ getEvents({ limit: 100 }).then(setEvents); },[]);

  const filteredReports = useMemo(()=>{
    const q = search?.toLowerCase() || '';
    return reports?.filter(r=> (r?.name||'').toLowerCase().includes(q) && (scope==='all' || r.scope===scope));
  },[reports, search, scope]);

  return (
    <div className="space-y-6">
      <div className="bg-white border border-gray-200 rounded-xl shadow-xl shadow-gray-200/50 p-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div>
            <div className="text-sm text-gray-600">Reports & Audit Center</div>
            <div className="text-2xl font-extrabold">Gallery & Audit Explorer</div>
          </div>
          <div className="flex gap-2">
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Find templates…" className="bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"/>
            <select value={scope} onChange={e=>setScope(e.target.value)} className="bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500">
              <option value="all">All</option>
              <option value="organization">Organization</option>
              <option value="portfolio">Portfolio</option>
              <option value="product">Product</option>
            </select>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredReports?.map(r=> (
          <div key={r.id} className="bg-white border border-gray-200 rounded-xl shadow-xl shadow-gray-200/50 p-4 transition-all hover:shadow-2xl">
            <div className="flex items-center justify-between">
              <div className="font-semibold text-gray-900">{r.name}</div>
              <span className="text-xs px-2 py-0.5 rounded-full border bg-gray-50 border-gray-200 text-gray-800">{r.scope}</span>
            </div>
            <div className="text-sm text-gray-600 mt-1">{r.description}</div>
            <div className="mt-3 flex gap-2">
              <button className="px-3 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-all">Preview</button>
              <button className="px-3 py-2 rounded-lg bg-gray-100 text-gray-800 border border-gray-200 hover:bg-gray-200 transition-all">Export PDF</button>
            </div>
          </div>
        ))}
      </div>

      <AuditExplorer events={events} />
    </div>
  );
}

function AuditExplorer({ events }){
  const [actor, setActor] = useState('');
  const [entityType, setEntityType] = useState('');
  const [action, setAction] = useState('');

  const rows = useMemo(()=>{
    return events?.filter(e=>
      (actor? String(e.actor_user_id)===actor : true) &&
      (entityType? e.entity_type===entityType : true) &&
      (action? e.action===action : true)
    );
  },[events, actor, entityType, action]);

  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-xl shadow-gray-200/50 p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold">Audit Log Explorer</div>
        <div className="flex gap-2">
          <input value={actor} onChange={e=>setActor(e.target.value)} placeholder="Actor user id" className="bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"/>
          <input value={entityType} onChange={e=>setEntityType(e.target.value)} placeholder="Entity (e.g., product)" className="bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"/>
          <select value={action} onChange={e=>setAction(e.target.value)} className="bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500">
            <option value="">Any action</option>
            <option value="create">create</option>
            <option value="update">update</option>
            <option value="access">access</option>
          </select>
        </div>
      </div>
      <div className="overflow-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left text-gray-600">
              <th className="py-2 pr-4">Time</th>
              <th className="py-2 pr-4">Actor</th>
              <th className="py-2 pr-4">Action</th>
              <th className="py-2 pr-4">Entity</th>
              <th className="py-2 pr-4">Details</th>
            </tr>
          </thead>
          <tbody>
            {rows?.map(r=> (
              <tr key={r.id} className="border-t border-gray-200 hover:bg-gray-50">
                <td className="py-2 pr-4">{new Date(r.timestamp).toLocaleString()}</td>
                <td className="py-2 pr-4">User {r.actor_user_id}</td>
                <td className="py-2 pr-4">{r.action}</td>
                <td className="py-2 pr-4">{r.entity_type} #{r.entity_id}</td>
                <td className="py-2 pr-4"><span className="text-xs text-gray-600">{r.after? 'after updated' : r.before? 'before' : '—'}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
